import React, { ReactNode, ButtonHTMLAttributes } from 'react';
import { TwStyle } from 'twin.macro';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  css?: TwStyle[];
}

const Button: React.FC<ButtonProps> = ({ children, disabled, ...props }) => {
  return (
    <button disabled={disabled} {...props}>
      {children}
    </button>
  );
};

export default Button;
